requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.executeWhenScriptLoaded('cart.js', () => {
      if (!customElements.get('product-form')) {
        class ProductForm extends HTMLElement {
          constructor() {
            super();

            this.onSubmitHandlerBound = this.onSubmitHandler.bind(this);
            this.onSellingPlanChangeBound = this.onSellingPlanChange.bind(this);
            this.onMediaControlButtonClickBound = this.onMediaControlButtonClick.bind(this);
            this.onMediaControlMouseenterBound = this.onMediaControlMouseenter.bind(this);
            this.onMediaControlMouseleaveBound = this.onMediaControlMouseleave.bind(this);
            this.onAnimatedButtonEndBound = this.onAnimatedButtonEnd.bind(this);
            this.formListenersBound = false;
            this.mediaControlListenersBound = false;
            this.mediaControlLeaveTimer = null;
            this.animatedButtonTimer = null;
          }

          connectedCallback() {
            this.form = this.querySelector('form');
            this.productInfo = this.closest('product-info');
            this.recipientFieldsInputs = this.productInfo?.querySelectorAll('.js-personalized-fields input, textarea');
            this.variantSelectsOrRadios = this.dataset.productType === 'card' ? this.querySelector('variant-selects, variant-radios') : document.getElementById(`variant-radios-${this.dataset.sectionId}`);

            if (this.form && !this.formListenersBound) {
              const variantInput = this.form.querySelector('[name=id]');
              if (variantInput) variantInput.disabled = false;

              this.form.addEventListener('submit', this.onSubmitHandlerBound);
              this.addEventListener('change', this.onSellingPlanChangeBound);
              this.formListenersBound = true;
            }

            this.findElements();
            this.initAnimatedButton();
            this.initMediaControlButtons();

            scriptController.scripts.push('product-form.js');
          }

          onSellingPlanChange(event) {
            if (event.target?.name !== 'selling_plan') return;

            this.toggleAddButton(false);
            this.productInfo?.querySelector('.product__price .price')?.classList.add('price--preorder');
          }

          initMediaControlButtons() {
            this.mediaControlButtonsWrapper = this.querySelector('.card__media-control-buttons');

            if (!this.mediaControlButtonsWrapper || this.mediaControlListenersBound) return;

            this.mediaControlButtons = this.mediaControlButtonsWrapper.querySelectorAll('button');
            if (!this.mediaControlButtons.length) return;

            this.mediaControlButtons.forEach((button) => {
              button.addEventListener('click', this.onMediaControlButtonClickBound);
            });
            this.mediaControlButtonsWrapper.addEventListener('mouseenter', this.onMediaControlMouseenterBound);
            this.mediaControlButtonsWrapper.addEventListener('mouseleave', this.onMediaControlMouseleaveBound);
            this.mediaControlListenersBound = true;
          }

          onMediaControlButtonClick(event) {
            this.media = this.media || this.querySelector('.media');
            if (!this.media || this.mediaControlButtons.length < 2) return;

            this.images = Array.from(this.media.querySelectorAll('img, template'));
            if (!this.images.length) return;

            this.currentImageIndex ??= (this.media.classList.contains('media--hover-effect') ? 1 : 0);

            if (event.currentTarget === this.mediaControlButtons[0]) {
              this.currentImageIndex = Math.max(0, this.currentImageIndex - 1);
            } else {
              this.currentImageIndex = Math.min(this.images.length - 1, this.currentImageIndex + 1);
            }

            this.mediaControlButtons[0].toggleAttribute('disabled', this.currentImageIndex === 0);
            this.mediaControlButtons[1].toggleAttribute('disabled', this.currentImageIndex === this.images.length - 1);

            let current = this.images[this.currentImageIndex];
            if (!current) return;

            if (current.tagName === 'TEMPLATE') {
              const image = current.content.cloneNode(true).querySelector('img');
              if (!image) return;

              current.replaceWith(image);
              this.images = Array.from(this.media.querySelectorAll('img, template'));
            }

            this.images.forEach((image, index) => image.classList.toggle('hidden', index !== this.currentImageIndex));
            this.media.classList.remove('media--hover-effect');
            this.classList.add('media-control-buttons--active');
          }

          onMediaControlMouseenter() {
            if (this.mediaControlLeaveTimer) {
              clearTimeout(this.mediaControlLeaveTimer);
              this.mediaControlLeaveTimer = null;
            }

            this.classList.add('media-control-buttons--active');
          }

          onMediaControlMouseleave() {
            if (this.mediaControlLeaveTimer) clearTimeout(this.mediaControlLeaveTimer);
            this.mediaControlLeaveTimer = setTimeout(() => {
              this.mediaControlLeaveTimer = null;
              if (this.isConnected) this.classList.remove('media-control-buttons--active');
            }, 200);
          }


          findElements() {
            this.quickAddModal = this.closest('quick-add-modal');
            this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
            [this.submitButton] = this.submitButtons;
          }

          toggleAddButton(disable = true, text, modifyClass = true, isSoldOut) {
            if (!this.form) return;
            const addButton = this.form.querySelector('[name="add"]');
            const addButtonText = this.form.querySelector('[name="add"] > span');
            let status = '';

            if (!addButton) return;

            if (disable) {
              addButton.setAttribute('disabled', 'disabled');
              if (text) addButtonText.innerHTML = text;
              status = 'disabled';
            } else {
              const isPreorder = this.form.querySelector('[name="selling_plan"]:checked') ||
                (window.themeSettings.preOrder && this.variantSelectsOrRadios?.getVariantData().inventory[this.variantSelectsOrRadios.currentVariant.id].quantity <= 0 && this.variantSelectsOrRadios?.currentVariant.available) ?
                true :
                false;

              addButton.removeAttribute('disabled');
              addButtonText.innerHTML = isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
              status = isPreorder ? 'preorder' : 'add';
            }

            if (isSoldOut !== undefined) {
              if (isSoldOut) {
                addButton.classList.add('button--sold-out');
                status = 'sold-out';
              } else {
                addButton.classList.remove('button--sold-out');
              }
            }

            addButton.setAttribute('data-status', status);

            if (this.dataset.productType !== 'card') {
              const productFootbarForm = document.getElementById(`product-form-${this.dataset.sectionId}-footbar`);
              if (!productFootbarForm) return;
              const footbarAddButton = productFootbarForm.querySelector('[name="add"]');
              const footbarAddButtonText = productFootbarForm.querySelector('[name="add"] > span');
              let status = '';

              if (disable) {
                footbarAddButton.setAttribute('disabled', 'disabled');
                if (text) footbarAddButtonText.innerHTML = text;
                status = 'disabled';
              } else {
                const isPreorder = this.form.querySelector('[name="selling_plan"]:checked') ||
                  (window.themeSettings.preOrder && this.variantSelectsOrRadios?.getVariantData().inventory[this.variantSelectsOrRadios.currentVariant.id].quantity <= 0 && this.variantSelectsOrRadios?.currentVariant.available) ?
                  true :
                  false;

                footbarAddButton.removeAttribute('disabled');
                footbarAddButtonText.innerHTML = isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
                status = isPreorder ? 'preorder' : 'add';
              }

              footbarAddButton.setAttribute('data-status', status);
            }

            if (!modifyClass) return;
          }

          initAnimatedButton() {
            this.animatedButton = this.querySelector('.js-animated-product-button');

            if (!this.animatedButton) return;

            this.animatedButtonTimeout = 2000;
            this.scheduleAnimatedButton();
          }

          scheduleAnimatedButton() {
            if (this.animatedButtonTimer) clearTimeout(this.animatedButtonTimer);
            this.animatedButtonTimer = setTimeout(() => {
              this.animatedButtonTimer = null;
              if (this.isConnected) this.animateButton();
            }, this.animatedButtonTimeout);
          }

          animateButton() {
            if (!this.animatedButton || !this.isConnected) return;

            this.animatedButton.removeEventListener('animationend', this.onAnimatedButtonEndBound);
            this.animatedButton.addEventListener('animationend', this.onAnimatedButtonEndBound, {
              once: true
            });
            this.animatedButton.classList.add('button--css-animate');
          }

          onAnimatedButtonEnd() {
            this.animatedButton?.classList.remove('button--css-animate');
            if (this.isConnected) this.scheduleAnimatedButton();
          }

          onSubmitHandler(event, callback, enableEventCall = true) {
            event.preventDefault();
            this.clearPersonalizedFieldsErrors();

            const quantityInput = this.form.querySelector('input[name="quantity"]');
            if (quantityInput && !quantityInput.checkValidity()) {
              quantityInput.reportValidity();
              return;
            }

            const personalizedFieldsErrors = this.validatePersonalizedFields();

            if (personalizedFieldsErrors.length) {
              this.onError(personalizedFieldsErrors);
              return;
            }

            event.target.focus();
            this.findElements();

            const isSubmitButtonLoading = this.submitButtons?.some(button => button.classList.contains('loading'));
            if (isSubmitButtonLoading) return;

            this.onError();
            cartBase.addToCart({
              body: new FormData(this.form),
              target: this,
              onLoadingToggle: (isLoading) => {
                this.toggleProductLoading({
                  isLoading,
                  processForm: false
                });
                cartBase.toggleCartLoading({
                  isLoading
                });

                if (!isLoading) {
                  this.quickAddModal?.hide(true);

                  if (callback) callback();
                }
              },
              enableEventCall
            });
          }

          clearPersonalizedFieldsErrors() {
            if (!this.recipientFieldsInputs) return;

            this.recipientFieldsInputs.forEach(element => {
              element.classList.remove('error');
            });
          }

          validatePersonalizedFields() {
            const errors = [];

            if (this.recipientFieldsInputs) {
              this.recipientFieldsInputs.forEach(element => {
                if (element.hasAttribute('required') && element.value.trim() === '') {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.emptyFieldError) == -1) {
                    errors.push(window.cartStrings.emptyFieldError);
                  }
                }

                if (element.getAttribute('maxlength') && element.value.length > parseInt(element.getAttribute('maxlength'))) {
                  element.classList.add('error');
                  if (errors.indexOf(window.cartStrings.maxLengthError) == -1) {
                    errors.push(window.cartStrings.maxLengthError.replace(
                      '{{ value }}',
                      element.getAttribute('maxlength')));
                  }
                }
              });
            }

            return errors;
          }

          toggleProductLoading({
            isLoading,
            processForm = true,
            processButton = true
          }) {
            this.findElements();

            if (processButton && this.submitButtons?.length) {
              this.submitButtons.forEach(button => {
                button.toggleAttribute('aria-disabled', isLoading);
                button.classList.toggle('loading', isLoading);
              });
            }

            if (processForm) {
              this.classList.toggle('product-form--loading', isLoading);
            }
          }

          onError(errors) {
            this.querySelector('error-messages')?.show(errors);
            document.querySelector('push-messages')?.push(errors);
          }

          disconnectedCallback() {
            if (this.formListenersBound) {
              this.form?.removeEventListener('submit', this.onSubmitHandlerBound);
              this.removeEventListener('change', this.onSellingPlanChangeBound);
              this.formListenersBound = false;
            }

            if (this.mediaControlListenersBound) {
              this.mediaControlButtons?.forEach((button) => {
                button.removeEventListener('click', this.onMediaControlButtonClickBound);
              });
              this.mediaControlButtonsWrapper?.removeEventListener('mouseenter', this.onMediaControlMouseenterBound);
              this.mediaControlButtonsWrapper?.removeEventListener('mouseleave', this.onMediaControlMouseleaveBound);
              this.mediaControlListenersBound = false;
            }

            if (this.mediaControlLeaveTimer) {
              clearTimeout(this.mediaControlLeaveTimer);
              this.mediaControlLeaveTimer = null;
            }

            if (this.animatedButtonTimer) {
              clearTimeout(this.animatedButtonTimer);
              this.animatedButtonTimer = null;
            }

            this.animatedButton?.removeEventListener('animationend', this.onAnimatedButtonEndBound);
            this.animatedButton?.classList.remove('button--css-animate');
          }
        }

        customElements.define('product-form', ProductForm);
      }
    });
  });
});
